import HeroSection from "../../components/HeroSection";

export default function Home() {
  return (
    <>
      <HeroSection />
    </>
  );
}
